import { render, staticRenderFns } from "./bulleted-list.vue?vue&type=template&id=fb1643d0&functional=true&"
import script from "./bulleted-list.vue?vue&type=script&lang=js&"
export * from "./bulleted-list.vue?vue&type=script&lang=js&"
import style0 from "./bulleted-list.vue?vue&type=style&index=0&id=fb1643d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports